import { GetterTree } from "vuex";
import { RootState } from "@/store/state";
import { ReportsState } from "./state";
import { reportsGetters } from "./types";
import moment from "moment";
import { CaseReport, Observation } from "@/store/reports/models";
import i18n from "@/i18n";

const getters: GetterTree<ReportsState, RootState> = {
  /** Case Reports **/

  [reportsGetters.ALL_CASES_REPORTS](state: ReportsState): any {
    return state.casesReports;
  },

  [reportsGetters.HAS_CASE_REPORT](state: ReportsState, getters: any): Function {
    return (caseId: string): boolean => {
      return !!getters.CASE_REPORT(caseId);
    };
  },

  [reportsGetters.CASE_REPORT](state: ReportsState): Function {
    return (caseId: string): any => {
      return state.casesReports[caseId];
    };
  },

  [reportsGetters.ACTIVE_CASE_REPORT](
    state: ReportsState,
    getters,
    rootState: RootState
  ): CaseReport {
    return getters.CASE_REPORT(rootState.activeCaseId);
  },

  [reportsGetters.SLIDE_REPORT](state: ReportsState, getters): Function {
    return (caseId: string, slideId: string): any => {
      const caseReport = getters.CASE_REPORT(caseId);
      return caseReport?.slidesReports[slideId] || {};
    };
  },

  [reportsGetters.OBSERVATION](state: ReportsState, getters): Function {
    return (caseId: string, slideId: string, key: string): any => {
      const slideReport = getters.SLIDE_REPORT(caseId, slideId) || {};
      return (
        slideReport.observations?.find((observation: Observation) => observation.key === key) || {}
      );
    };
  },

  [reportsGetters.CASE_COMMENTS](state: ReportsState, getters): Function {
    return (caseId: string): string => {
      const caseReport = getters.CASE_REPORT(caseId);
      return caseReport?.comments;
    };
  },

  [reportsGetters.CASE_REPORT_COMPLETE](state: ReportsState, getters): boolean {
    return getters.ACTIVE_CASE_REPORT?.isComplete;
  },

  [reportsGetters.COMPLETED_BY](state: ReportsState, getters): boolean {
    return getters.ACTIVE_CASE_REPORT?.completedBy;
  },

  [reportsGetters.COMPLETED_ON](state: ReportsState, getters, rootState: RootState): String {
    const locale = i18n.global.locale.value === "swe" ? "sv" : i18n.global.locale.value;
    return moment
      .unix(getters.ACTIVE_CASE_REPORT?.completedOn)
      .locale(locale)
      .format("dddd, MMMM Do YYYY, h:mm a");
  },

  [reportsGetters.SLIDE_COMMENTS](state: ReportsState, getters): Function {
    return (caseId: string, slideId: string): any => {
      const slideReport = getters.SLIDE_REPORT(caseId, slideId) || {};
      return slideReport?.comments;
    };
  },

  [reportsGetters.SLIDE_OBSERVATIONS](state: ReportsState, getters): Function {
    return (caseId: string, slideId: string): any => {
      const caseReport = getters.CASE_REPORT(caseId);
      return caseReport?.slidesReports[slideId]?.observations || [];
    };
  },

  [reportsGetters.FILLED_SLIDE_OBSERVATIONS](state: ReportsState, getters): Function {
    return (caseId: string, slideId: string): any => {
      const slideObservations = getters.SLIDE_OBSERVATIONS(caseId, slideId) || [];
      return slideObservations.filter((observation: Observation) => {
        return (
          observation.value && (typeof observation?.value === "number" || observation?.value.length)
        );
      });
    };
  },

  [reportsGetters.ACTIVE_REPORT_ID](state: ReportsState): number | null {
    return state.activeReportId;
  },
};

export default getters;
